<template>
  <v-widget
    v-if="customer.subscription"
    :title="$t('Subscription')"
    class="mb-4"
  >
    <div slot="widget-header-action">
      <v-tooltip top>
        <v-switch
          slot="activator"
          v-model="customer.subscription.email"
          color="primary"
          class="mt-3"
          @change="editSubscriptions"
        />
        <span>{{ $t('For marketing emails') }}</span>
      </v-tooltip>
    </div>
    <div slot="widget-content">
      <v-list subheader>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon
              class="primary"
              color="white"
            >
              email
            </v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{ customer.email }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </div>
  </v-widget>
</template>

<script>

export default {
  name: 'CustomerSubscriptions',

  props: {
    customer: {
      type: Object,
      required: true
    }
  },

  methods: {
    editSubscriptions () {
      this.customer.isChanged = true
    }
  }
}
</script>
